import axiosUser from "../../store/axios/axios-user";

const storageKey = (moduleName) => `view_filters_${moduleName}`;

const readLocal = (moduleName) => {
    try {
        const raw = localStorage.getItem(storageKey(moduleName));
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
    } catch (e) {
        return [];
    }
};

const removeLocal = (moduleName) => {
    try { localStorage.removeItem(storageKey(moduleName)); } catch (e) {}
};

export const loadHiddenColumns = async (moduleName) => {
    try {
        const r = await axiosUser.get(`/view_preferences?module=${encodeURIComponent(moduleName)}`);
        const remote = r && r.data && Array.isArray(r.data.hidden_columns) ? r.data.hidden_columns : [];
        if (remote.length === 0) {
            const local = readLocal(moduleName);
            if (local.length > 0) {
                await saveHiddenColumns(moduleName, local);
                removeLocal(moduleName);
                return local;
            }
        }
        return remote;
    } catch (e) {
        return readLocal(moduleName);
    }
};

export const saveHiddenColumns = async (moduleName, hidden) => {
    const arr = Array.isArray(hidden) ? hidden : [];
    try {
        await axiosUser.post(`/view_preferences`, { module: moduleName, hidden_columns: arr });
        return { ok: true };
    } catch (e) {
        return { ok: false, error: e };
    }
};
